import Vuex from 'vuex'
import {getStore, setStore} from "@/utils/mUtils";

export default new Vuex.Store({
    //数据，相当于data
    state: {
        language: getStore('language') === null ? 'zh' : getStore('language'),
        mainRefreshKey: 0,
        userHeader: JSON.parse(getStore('userHeader')),
        userInfo: JSON.parse(getStore('userInfo')),
    },
    getters: {},
    //里面定义方法，操作state中对象的方法
    mutations: {
        setLanguage(state, language){
          state.language = language;
          setStore('language', language)
        },
        setMainRefreshKey(state) {
            state.mainRefreshKey++;
        },
        setUserHeader(state, userHeader) {
            state.userHeader = userHeader;
            setStore('userHeader', userHeader)
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
            setStore('userInfo', userInfo)
        },
    },
    //异步操作mutation
    actions: {},
    modules: {}
});
